import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    button: {
        background: theme.palette.secondary.light,
        boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
        borderRadius: 4,
        width: "100%",
        border: "none",
        color: theme.palette.text.primary,
        textAlign: "left",
        padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
        display: "flex",
    },
    buttonBox: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(4),
    },
    buttonText: {
        fontSize: `25px !important`,
        fontWeight: "700 !important",
    },
}));
